import React from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Button } from 'semantic-ui-react';

import { SubscriptionDetail } from '@/types/subscriptions/subscription';
import { pages, formatRoute } from '@/settings/pages';

type Props = {
  subscription: SubscriptionDetail;
};

export const EditBtn: React.FC<Props> = ({ subscription }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const path = pages.subscription.edit;
  const params: { requestCode: string } = {
    requestCode: subscription.requestCode,
  };

  const onClick = () => navigate(formatRoute(path, params));

  return (
    <Button
      data-test="do-edit"
      disabled={!subscription.isUpdatable}
      primary={true}
      type="submit"
      onClick={onClick}
    >
      {t('ui.action.changeOrder')}
    </Button>
  );
};
